<template>
    <div class="table offer-info">
        <div v-for="round in rounds" v-if="round.ssrRoundSupplierPqcps.length>0 || round.ssrRoundSupplierPcns.length>0">
            <div>Round {{round.roundNumber}}
                <!--下载本轮次Excel-->
                <el-button type="primary" @click="offerDownload(round.ttSsrRoundId)">{{$t('ssrManage.offerDownload')}}</el-button>
            </div>
            <pqcp-table v-if="round.ssrRoundSupplierPqcps != null && round.ssrRoundSupplierPqcps.length>0" :data="round.ssrRoundSupplierPqcps" :can-edit="canEdit" :can-edit-freight-forcast="canEditFreightForcast"></pqcp-table>
            <pcn-table v-if="round.ssrRoundSupplierPcns != null && round.ssrRoundSupplierPcns.length>0" :data="round.ssrRoundSupplierPcns" :can-edit="canEdit" ></pcn-table>
            <!--底部操作按钮-->
        </div>
        <el-row type="flex" justify="center" style="padding-top: 15px;">
            <el-button :key="'save'" v-if="canEditFreightForcast" type="primary" @click="saveLogisticInfo()">Save As Draft</el-button>
            <el-button key="downloadAll" v-if="roundIds.length>1" type="primary" @click="offerDownload(roundIds)">Download All</el-button>
        </el-row>
    </div>
</template>
<script>
    import router from '../../../router';
    import {apiService} from "@/api/ssr-manage/ssr-manage";
    import {Message} from "element-ui";
    import commonMethods from "@/utils/commonMethods";
    import PqcpTable from "@/components/page/ssr-manage/pqcp-table";
    import PcnTable from "@/components/page/ssr-manage/pcn-table";
    import commonFun from "@/utils/commonFun";

    export default {
        name: '',
        extends: commonMethods,
        components: {PcnTable, PqcpTable},
        props: {
            rounds: Array
        },
        computed: {
            canEditFreightForcast() {
                return false;
                // let that = this;
                // return () => {
                //     let functionCode = null;
                //     if (this.$store.state.ssr.data.type == "SSR") {
                //         functionCode = "Input_SSR_logistic_Info";
                //     } else if (this.$store.state.ssr.data.type == "RFP") {
                //         functionCode = "Input_RFP_logistic_Info";
                //     }
                //     if (that.rounds.some(round => {
                //         return ['ISSUED','QUOTED','MARKED'].indexOf(round.status) >= 0 && round.ssrRoundSupplierPqcps.length > 0;
                //     })) {
                //         return commonFun.havePermission(functionCode);
                //     } else {
                //         return false;
                //     }
                // }
            },
            canEdit() {
                return false;
            },
            roundIds() {
                return this.rounds.filter(round=>round.ssrRoundSupplierPqcps.length>0 || round.ssrRoundSupplierPcns.length>0).map(round=>round.ttSsrRoundId)
            }
        },
        data() {
            return {
                radio:'1',
                labelPosition: 'right',
                tableList: [{ssrNo: 'aaa',radio:1}],
                facilityOption: [],
                currencyOption: [],
            }
        },
        created() {
        },
        methods: {
            saveLogisticInfo() {
                let that = this;
                let pqcpArr = [];
                this.rounds.forEach(round => {
                    pqcpArr.push(...round.ssrRoundSupplierPqcps.map(pqcp => {
                        return {
                            freightForecast:pqcp.freightForecast,
                            ttSsrRoundSupplierPqcpId:pqcp.ttSsrRoundSupplierPqcpId
                        }
                    }));
                })
                apiService.saveLogisticInfo(pqcpArr).then(res => {
                    if (res.code == 200) {
                        Message.success('Operate Success');
                    }
                });
            },
            offerDownload(roundIds){
                this.confirm(this.$t("ssrManage.selectPqcpOrder"),null,"Order by Supplier","Order by Price",{
                    width:1000
                }).then(value =>{
                    apiService.exportPqcp(roundIds,"supplierName");
                }).catch((action)=>{
                    if (action == 'cancel') {
                        apiService.exportPqcp(roundIds, "price");
                    }
                })
            }
        }
    }
</script>
<style>
    .offer-info .el-table__body .el-radio .el-radio__label{
        display: inline-block!important;
    }
</style>
